var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.205,
    height: 12.205,
    viewBox: "0 0 12.205 12.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "booking",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168926",
    "data-name": "Path 168926",
    d: "M10.89.766H9.907V.358a.358.358,0,1,0-.715,0V.766H7.609V.358a.358.358,0,1,0-.715,0V.766H5.311V.358a.358.358,0,0,0-.715,0V.766H3.013V.358a.358.358,0,0,0-.715,0V.766H1.315A1.317,1.317,0,0,0,0,2.081V10.89a1.317,1.317,0,0,0,1.315,1.315H10.89a1.317,1.317,0,0,0,1.315-1.315V2.081A1.317,1.317,0,0,0,10.89.766Zm-9.575.715H2.3V1.89a.358.358,0,1,0,.715,0V1.481H4.6V1.89a.358.358,0,1,0,.715,0V1.481H6.894V1.89a.358.358,0,1,0,.715,0V1.481H9.192V1.89a.358.358,0,1,0,.715,0V1.481h.983a.6.6,0,0,1,.6.6v.983H.715V2.081a.6.6,0,0,1,.6-.6ZM10.89,11.49H1.315a.6.6,0,0,1-.6-.6V3.779H11.49V10.89A.6.6,0,0,1,10.89,11.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168927",
    "data-name": "Path 168927",
    d: "M74.189,208.867H72.657a.358.358,0,0,0-.358.358v1.532a.358.358,0,0,0,.358.358h1.532a.358.358,0,0,0,.358-.358v-1.532A.358.358,0,0,0,74.189,208.867Zm-.358,1.532h-.817v-.817h.817Z",
    transform: "translate(-70.576 -203.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168928",
    "data-name": "Path 168928",
    d: "M347.323,208.867h-1.532a.358.358,0,0,0-.358.358v1.532a.358.358,0,0,0,.358.358h1.532a.358.358,0,0,0,.358-.358v-1.532A.358.358,0,0,0,347.323,208.867Zm-.358,1.532h-.817v-.817h.817Z",
    transform: "translate(-337.199 -203.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168929",
    "data-name": "Path 168929",
    d: "M74.189,337.4H72.657a.358.358,0,0,0-.358.358v1.532a.358.358,0,0,0,.358.358h1.532a.358.358,0,0,0,.358-.358v-1.532A.358.358,0,0,0,74.189,337.4Zm-.358,1.532h-.817v-.817h.817Z",
    transform: "translate(-70.576 -329.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168930",
    "data-name": "Path 168930",
    d: "M347.323,337.4h-1.532a.358.358,0,0,0-.358.358v1.532a.358.358,0,0,0,.358.358h1.532a.358.358,0,0,0,.358-.358v-1.532A.358.358,0,0,0,347.323,337.4Zm-.358,1.532h-.817v-.817h.817Z",
    transform: "translate(-337.199 -329.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168931",
    "data-name": "Path 168931",
    d: "M210.755,337.4h-1.532a.358.358,0,0,0-.358.358v1.532a.358.358,0,0,0,.358.358h1.532a.358.358,0,0,0,.358-.358v-1.532A.358.358,0,0,0,210.755,337.4Zm-.358,1.532h-.817v-.817h.817Z",
    transform: "translate(-203.886 -329.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168932",
    "data-name": "Path 168932",
    d: "M208.648,218.384l-.83.83-.289-.289a.358.358,0,0,0-.506.506l.542.542a.358.358,0,0,0,.506,0l1.083-1.083a.358.358,0,0,0-.506-.506Z",
    transform: "translate(-201.986 -213.076)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/Booking.0f513ee5df2246ea6a30b708c1c89e82.svg";
export { ForwardRef as ReactComponent };